var r = /* @__PURE__ */ ((e) => (e.Definition = "definition", e.Ordered = "ordered", e.Unordered = "unordered", e))(r || {});
const d = Symbol("listVariant"), o = "unordered";
export {
  o as DefaultVariant,
  d as ListVariantKey,
  r as VariantsEnum
};
